// extracted by mini-css-extract-plugin
export default {"container":"minus_container__cKZvz","content":"minus_content__zWLTL"};